import css from 'styled-jsx/css';

export default css`
.roomba-price-banner {
  border-radius: 16px;
  overflow: hidden;
  .banner-video-desktop,
  .banner-video-mobile {
    width: 100%;
    :global(img) {
      display: flex;
    }
  }
  .banner-video-container {
      position: relative;
  }
  .banner-overlay {
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 16px;
    .title-desktop {
      display: none;
      margin: 20px;
      margin-top: 30px;
      //margin-right: 30px;
    }
    .title-mobile {
      margin: 20px;
      margin-right: 29%;
    }
  }
  .advantages {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background-color: white;
    background-color: #eeeeee;
    gap: 25px;
    padding: 0.8rem 1rem 1.5rem 1rem;
    .advantage-item {
      display: flex;
      gap: 0.5rem;
      flex-direction: column;
      align-items: center;
    }
  }
  .banner-video-desktop {
    display: none;
  }
}
@media screen and (min-width: 768px) {
  .roomba-price-banner {
    .banner-video-desktop {
      display: block !important;
    }
    .banner-video-mobile {
      display: none;
    }
    .advantages {
      grid-template-columns: repeat(4, 1fr);
      gap: 45px;
    }
    .banner-overlay {
      justify-content: start;
      .title-desktop {
        margin-top: 20px;
        display: block;
      }
      .title-mobile {
        display: none;
      }
    }
  }
}
`;
